(() => {
  const selectors = {
    slider: '.videoReviews__videoContainer',
    sliderDs: '.videoReviews__videoContainer--ds',
    videoDesktop: '.videoReviews__video--desktop',
    videoMobile: '.videoReviews__video--mobile',
    wrapper: '.videoReviews__videoBlock',
    controls: '.js-videoReviews__controls',
    control: '.videoReviews__control',
    video: '.videoReviews__video',
    score: '.videoReviews__score',
    slickDots: '.slick-dots',
    slickNext: '.slick-next',
    slickPrev: '.slick-prev',

    pause: 'videoReviews__control--pause',
    play: 'videoReviews__control--play',
    active: 'videoReviews__control--active',
  }

  let slickSettings = {
    infinite: false,
    dots: true,
    arrows: true,
    slidesToShow: 1.25,
    slidesToScroll: 1,
    variableWidth: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          dots: false
        }
      }
    ]
  };

  const sliderDs = document.querySelector(selectors.sliderDs);
  if (sliderDs) {
    slickSettings.slidesToShow = 1.19;
  }

  function videoSelector(wrapper) {
    let vidSelector = selectors.video;

    if (wrapper.querySelector(selectors.videoDesktop)) {
      vidSelector = window.screen.width >= 769 ? selectors.videoDesktop : selectors.videoMobile;
    }

    return vidSelector;
  }

  function scoreRatingUpdate () {
    const scoreElement = document.querySelector(selectors.score);
    const scoreCount = scoreElement?.getAttribute('data-rating').replace(',', '.');

    if (scoreCount) {
      scoreElement.style.width = ((+scoreCount) * 100) / 5 + '%';
    }
  }

  function changeVideo(controlTarget) {
    const wrapper = controlTarget.closest(selectors.wrapper);
    const currentVideo = wrapper.querySelector(`${videoSelector(wrapper)} video`);

    currentVideo.addEventListener('ended', function() {
      currentVideo.pause();
      controlTarget.classList.remove(selectors.active);
    })

    if (!controlTarget.classList.contains(selectors.active)) {
      currentVideo.play();
      controlTarget.classList.add(selectors.active);
    } else {
      currentVideo.pause();
      controlTarget.classList.remove(selectors.active);
    }
  }

  function toggleControls(event) {
    const controlTarget = event.currentTarget;

    changeVideo(controlTarget);
  }

  function updateArrowPosition () {
    const wrapper = document.querySelector(selectors.slider)
    const container = wrapper.querySelector(selectors.slickDots);

    if (container) {
      const nextButton = wrapper.querySelector(selectors.slickNext);
      const prevButton = wrapper.querySelector(selectors.slickPrev);

      container.insertAdjacentElement('afterend', nextButton);
      container.insertAdjacentElement('beforebegin', prevButton);

      prevButton.style.right = (container.getBoundingClientRect().width + 75) + 'px';
      nextButton.style.left = (container.getBoundingClientRect().width + 80) + 'px';
    }
  }

  $(selectors.slider).slick(slickSettings);
  scoreRatingUpdate();
  updateArrowPosition();
  const controls = document.querySelectorAll(selectors.controls);

  controls.forEach((control) => {
    control.addEventListener('click', toggleControls);
  });

  window.addEventListener('resize', () => {
    $(selectors.slider).slick('resize');
  });
})();
